document.addEventListener('turbolinks:load', () => {
	var role_id = $('#user_role_id').val();

	if (role_id == 2 || role_id == 8) {
		$('#user_seller_id').parent().show();
		$('label[for="user_seller_id"]').show();
		$('#user_technician_id').parent().hide();
		$('label[for="user_technician_id"]').hide();
		$('#user_customer_id').parent().hide();
		$('label[for="user_customer_id"]').hide();

	} else if (role_id == 4 || role_id == 5) {
		$('#user_technician_id').parent().show();
		$('label[for="user_technician_id"]').show();
		$('#user_seller_id').parent().hide();
		$('label[for="user_seller_id"]').hide();
		$('#user_customer_id').parent().hide();
		$('label[for="user_customer_id"]').hide();

	} else if (role_id == 7) {
		$('#user_customer_id').parent().show();
		$('label[for="user_customer_id"]').show();
		$('#user_technician_id').parent().hide();
		$('label[for="user_technician_id"]').hide();
		$('#user_seller_id').parent().hide();
		$('label[for="user_seller_id"]').hide();

	} else {
		$('#user_technician_id').parent().hide();
		$('label[for="user_technician_id"]').hide();
		$('#user_seller_id').parent().hide();
		$('label[for="user_seller_id"]').hide();
		$('#user_customer_id').parent().hide();
		$('label[for="user_customer_id"]').hide();
	}

	return $('#user_role_id').change(function() {
		role_id = $('#user_role_id').val();

		if (role_id == 2 || role_id == 8) {
			$('#user_seller_id').parent().show();
			$('label[for="user_seller_id"]').show();
			$('#user_technician_id').parent().hide();
			$('label[for="user_technician_id"]').hide();
			$('#user_customer_id').parent().hide();
			$('label[for="user_customer_id"]').hide();

		}
		else if (role_id == 4 || role_id == 5) {
			$('#user_technician_id').parent().show();
			$('label[for="user_technician_id"]').show();
			$('#user_seller_id').parent().hide();
			$('label[for="user_seller_id"]').hide();
			$('#user_customer_id').parent().hide();
			$('label[for="user_customer_id"]').hide();

		} else if (role_id == 7) {
			$('#user_customer_id').parent().show();
			$('label[for="user_customer_id"]').show();
			$('#user_technician_id').parent().hide();
			$('label[for="user_technician_id"]').hide();
			$('#user_seller_id').parent().hide();
			$('label[for="user_seller_id"]').hide();

		} else {
			$('#user_seller_id').parent().hide();
			$('label[for="user_seller_id"]').hide();
			$('#user_technician_id').parent().hide();
			$('label[for="user_technician_id"]').hide();
			$('#user_customer_id').parent().hide();
			$('label[for="user_customer_id"]').hide();
		}
	});
});